import { gql } from "@apollo/client";

export const GET_EMPLOYEES = gql`
  query getAllEmployees(
    $skip: Float!
    $take: Float!
    $filter: UserFilterInput
  ) {
    getAllEmployees(skip: $skip, take: $take, filter: $filter) {
      count
      result {
        id
        firstName
        lastName
        email
        roles {
          id
          role
        }
        isForceResetPassword
        isInvited
        isEmailVarified
        isFirstTimeSetPassword
        isDeleted
        emailToken
        isActive
        isApproved
        displayName
        phoneno
        createdAt
        isUserVerified
        userOrg {
          isVerified
          isIndividual
          isDeleted
          isMergeOrganization
          mergeOwnOrganization {
            id
          }
          id
          roles {
            key
            id
          }
          organization {
            id
            name
            leagalName
            phoneNo
            pin
            email
            isSeller
            website
            locations {
              street1
              street2
              countryName
              stateName
              cityName
              pincode
            }
          }
        }
      }
    }
  }
`;

export const GET_EMPLOYEE_BY_ID = gql`
  query getUserId($userId: String!) {
    getUserById(userId: $userId) {
      id
      name
      firstName
      lastName
      email
      roles {
        id
        role
      }
      isDeleted
      displayName
      phoneno
      createdAt
      isApproved
      isUserVerified
    }
  }
`;
